import { IconProps } from 'src/utils/icon';

const ChevronUpIcon: React.FC<IconProps> = ({ size = 1 }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 13"
  >
    <path stroke="currentColor" strokeWidth="3" d="M19 11l-9-8-9 8" />
  </svg>
);

export default ChevronUpIcon;
